import { ProductModel } from '@/product/models/ProductModel'
import { ShipmentModel } from '../../shipment/models/ShipmentModel'

export class OrderItemModel {
    id?:string|number = undefined
    amount:number = 1
    price:number = 0
    listPrice:number = 0
    discountValue:number = 0
    total:number = 0
    product:ProductModel|undefined = undefined    
    shipments:ShipmentModel[] = []

    constructor(o?:Partial<OrderItemModel>) {
        Object.assign(this, o)

        this._parseProduct();
        this._parseShipments();
    }

    getDiscountValue():number {
        return this.discountValue || 0;
    }

    getTotal():number {
        const result = this.total - this.getDiscountValue();

        if (result > 0) {
            return result;
        }

        return 0;
    }

    private _parseProduct():void {
        this.product = new ProductModel(this.product);
    }

    private _parseShipments():void {
        this.shipments = this.shipments.map((shipment) => {
            return new ShipmentModel(shipment);
        });
    }
}
